import React from 'react'
import * as jsjoda from '@js-joda/core'

export const useCurrentTime = (onTick:(_:jsjoda.Instant) => void,frequency:number=100) : void => {
  React.useEffect(() => {
    const interval = window.setInterval(() => onTick(jsjoda.Instant.now()),frequency)
    return () => window.clearInterval(interval)
  },[])
}

export default useCurrentTime
